module.exports = __webpack_public_path__ + "static/media/img9mob.fd37cec8.jpg";